import FclgLogo from '../assets/icon/fclg.svg';
import LogoTitle from '../assets/icon/logo-title.svg';
import Title from '../assets/icon/title-white.png';
import YellowLogo from '../assets/icon/logo-yellow.svg';

const Logo = (props) => <img alt="logo" src={FclgLogo} {...props} />;
const LogoT = (props) => <img alt="logo" src={LogoTitle} {...props} />;
const WTitle = (props) => <img alt="logo" src={Title} {...props} />;
const YLogo = (props) => <img alt="logo" src={YellowLogo} {...props} />;

const SwithIcon = (props) => {
	const { type } = props;
	const IconMap = {
		'tb-logo-y': <YLogo {...props} />,
		'fclg-logo': <Logo {...props} />,
		'tb-logo-t': <LogoT {...props} />,
		'tb-title-w': <WTitle {...props} />
	};
	return IconMap[type] ? IconMap[type] : <p>{`${type}icon不存在`}</p>;
};

function TBIcon(props) {
	return <SwithIcon {...props} />;
}
export default TBIcon;
